import styled, { css } from 'styled-components';
import { Flex } from '@mixins';

export const Container = styled(Flex)`
${() => css`
    transition: left 0.1s linear;
  `}
`;
